import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/p-team.webp";
import projImg2 from "../assets/img/p-music.jpg";
import projImg3 from "../assets/img/p-cegment.webp";
import projImg4 from "../assets/img/p-Car-Rental.jpg";
import projImg5 from "../assets/img/p-Drone.jpg";
import projImg6 from "../assets/img/sign.jpg";
import projImg7 from "../assets/img/p-vehicle.webp";
import projImg9 from "../assets/img/p-lane.jpg";
import projImg10 from "../assets/img/p-face.jpg";
import projImg11 from "../assets/img/p-object.jpg";
import projImg12 from "../assets/img/p-emojify.jpg";
import projImg13 from "../assets/img/p-diabetes.jpg";
import projImg14 from "../assets/img/p-traffic.jpg";
import projImg15 from "../assets/img/p-mall.jpg";
import projImg16 from "../assets/img/p-salary.jpg";
import projImg17 from "../assets/img/p-sales.jpg";
import projImg18 from "../assets/img/p-music-genre.jpg";



import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Projects = () => {

  const projects = [
    {
      title: "Messaging App with Distracting content filtering",
      description: "Deep Learning and NLP",
      imgUrl: projImg1,
    },
    {
      title: "Music Genre Classification",
      description: "Applied Machine Learning",
      imgUrl: projImg2,
    },
    {
      title: "Semantic Segmentation of images using Active learning",
      description: "Computer Vision",
      imgUrl: projImg3,
    },
    {
      title: "Traffic Sign Detection",
      description: "Deep Learning",
      imgUrl: projImg7,
    },
    {
      title: "Sign Language Detection",
      description: "Deep Learning",
      imgUrl: projImg6,
    },
    {
      title: "Drone Detection",
      description: "Deep Learning",
      imgUrl: projImg5,
    },
    
  ];

  const projects2 = [
    {
      title: "Vehicle Detection",
      description: "Computer Vision",
      imgUrl: projImg7,
    },
    {
      title: "Semantic Segmentation of images using Active learning",
      description: "Computer Vision",
      imgUrl: projImg3,
    },
    {
      title: "Advanced Lane Detection",
      description: "Computer Vision and Deep learning",
      imgUrl: projImg9,
    },
    {
      title: "Face Detection",
      description: "Computer Vision",
      imgUrl: projImg10,
    },
    {
      title: "Object Recognition",
      description: "Computer Vision and Deep Learning",
      imgUrl: projImg11,
    },
    {
      title: "Emojify",
      description: "Computer Vision and Deep Learning",
      imgUrl: projImg12,
    },
    
  ];

  const projects3 = [
    {
      title: "Diabetes Predictor",
      description: "Statistical Machine Learning",
      imgUrl: projImg13,
    },
    {
      title: "Traffic Forecast",
      description: "Applied Machine Learning",
      imgUrl: projImg14,
    },
    {
      title: "Songs Recommendation Engine",
      description: "Applied Machine Learning",
      imgUrl: projImg18,
    },
    {
      title: "Mall Customer Segmentation",
      description: "Statistical Machine Learning",
      imgUrl: projImg15,
    },
    {
      title: "Salary prediction",
      description: "Statistical Machine Learning",
      imgUrl: projImg16,
    },
    {
      title: "Black Friday Sales Prediction",
      description: "Statistical Machine Learning",
      imgUrl: projImg17,
    },
    
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn": ""}>
                <h2>Projects</h2>
                <p>I've always been convinced that working on a project enables you to work independently and make judgments on the path to go in. Some of my works are in the following domains</p>
                <Tab.Container id="projects-tabs" defaultActiveKey="first">
                  <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                    <Nav.Item>
                      <Nav.Link eventKey="first">Deep Learning</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="second">Computer Vision</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="third">Machine Learning</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content id="slideInUp" className={isVisible ? "animate__animated animate__slideInUp" : ""}>
                    <Tab.Pane eventKey="first">
                      <Row>
                        {
                          projects.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="second">
                    <Row>
                        {
                          projects2.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                    <Tab.Pane eventKey="third">
                    <Row>
                        {
                          projects3.map((project, index) => {
                            return (
                              <ProjectCard
                                key={index}
                                {...project}
                                />
                            )
                          })
                        }
                      </Row>
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2}></img>
    </section>
  )
}
